<template>
  <footer class="footer text-center py-5">
    <div class="container">
      <p class="m-0 small">Copyright &copy; Fabio Costa 2021</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
.footer {
  background-color: rgba(187, 188, 231, 0.9);
  margin-top: auto;
}
</style>
